import { render, staticRenderFns } from "./ProjectResultConfigModal.vue?vue&type=template&id=120c384b&scoped=true"
import script from "./ProjectResultConfigModal.vue?vue&type=script&lang=js"
export * from "./ProjectResultConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120c384b",
  null
  
)

export default component.exports